import { useEffect, useState } from "react";
import { SelectWithSearchAndSelectAll } from "components/select-with-search-select-all";
import { useConsolidatedStocksContext } from "features/consolidated-stocks/context";
import {
  searchBusinessUnit,
  searchLabeledFamily,
  searchMaterialGroup,
  searchStockStatus
} from "services/filters.service";
import { isUseFilterDefault } from "utils/user";
import { IconTrash } from "components/icons/icn-index.icon";
import intl from "react-intl-universal";
import { verifyIsFiltered } from "utils/custom-functions";
import { initialFilterValues } from "./utils";
import { ConsolidatedStocksTooltip } from "../consolidated-stocks-tooltip";
import * as S from "./styled";
import { IconFilterActive } from "components/icons/icn-filter-active.icon";
import { IconFilterInactive } from "components/icons/icn-filter-inactive.icon";
import ButtonIcon from "components/button-icon";

export const ConsolidatedStocksFilter = () => {
  const { filter, setFilter: setFilterContext } = useConsolidatedStocksContext();
  const useFilterDefault = isUseFilterDefault();

  const [localFilter, setLocalFilter] = useState(filter);

  const [businessUnits, setBusinessUnits] = useState([]);
  const [labeledFamilies, setLabeledFamilies] = useState([]);
  const [materialGroup, setMaterialGroup] = useState([]);
  const [stockStatus, setStockStatus] = useState([]);

  const updateLocalFilter = (prop, value) => {
    setLocalFilter(prev => ({ ...prev, [prop]: value }));
  };

  const loadFilters = async () => {
    const [_businessUnits, _labeledFamilies, _materialGroup, _stockStatus] = await Promise.all([
      searchBusinessUnit(useFilterDefault),
      searchLabeledFamily(useFilterDefault),
      searchMaterialGroup(useFilterDefault),
      searchStockStatus()
    ]);
    setBusinessUnits(_businessUnits);
    setLabeledFamilies(_labeledFamilies);
    setMaterialGroup(_materialGroup);
    setStockStatus(_stockStatus);
  };

  const handleFilter = () => {
    const newFilter = {
      ...localFilter,
      _page: 0,
      _size: filter._size || 10
    };

    setFilterContext(newFilter);
  };

  const clearFilters = () => {
    setLocalFilter(initialFilterValues);
    setFilterContext(initialFilterValues);
  };

  useEffect(() => {
    loadFilters();
  }, []);

  const getIconFilter = () =>
    verifyIsFiltered(localFilter)
      ? <span data-testid="icon-filter-active"><IconFilterActive /></span>
      : <span data-testid="icon-filter-inactive"><IconFilterInactive /></span>;

  return (
    <S.Wrapper>
      <SelectWithSearchAndSelectAll
        label={intl.get("commons.destiny")}
        options={businessUnits}
        onChange={value => updateLocalFilter("BusinessUnitId", value)}
        values={localFilter.BusinessUnitId}
        valueField="Id"
        labelField="Description"
        style={{ background: "var(--color-contrast-white)" }}
        hideSelectAll
      />
      <SelectWithSearchAndSelectAll
        label={intl.get("commons.wallet")}
        options={materialGroup}
        onChange={value => updateLocalFilter("MaterialGroupId", value)}
        values={localFilter.MaterialGroupId}
        valueField="Id"
        labelField="Description"
        style={{ background: "var(--color-contrast-white)" }}
        hideSelectAll
      />
      <SelectWithSearchAndSelectAll
        label={intl.get("commons.labeledFamily")}
        options={labeledFamilies}
        onChange={value => updateLocalFilter("LabeledFamilyId", value)}
        values={localFilter.LabeledFamilyId}
        valueField="Id"
        labelField="Description"
        style={{ background: "var(--color-contrast-white)" }}
        hideSelectAll
      />
      <SelectWithSearchAndSelectAll
        label={intl.get("management.statusStock")}
        options={stockStatus}
        onChange={value => updateLocalFilter("StockStatus", value)}
        values={localFilter.StockStatus}
        valueField="Id"
        labelField="Description"
        style={{ background: "var(--color-contrast-white)" }}
        hideSelectAll
      />
      <S.ButtonWrapper>
        <ButtonIcon
          buttonType="default"
          buttonText={intl.get("filters.cleanFilter")}
          onClick={clearFilters}
          buttonIcon={<IconTrash />}
          className="btn-filter"
          style={{ width: "166px" }}
        />
        <ButtonIcon
          buttonType="primary"
          buttonText={intl.get("filters.generalFilter")}
          onClick={handleFilter}
          buttonIcon={getIconFilter()}
          className="btn-filter"
          style={{ width: "166px" }}
        />
        <ConsolidatedStocksTooltip />
      </S.ButtonWrapper>
    </S.Wrapper>
  );
};